import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ControllerService } from '../shared/services/controller.service';
import { environment } from '../../environments/environment';


@Component({
    selector: 'app-research',
    templateUrl: './research.component.html',
    styleUrls: ['./research.component.scss'],
    standalone: false
})
export class ResearchComponent implements OnInit {

  constructor(public controller: ControllerService, private doms: DomSanitizer ) { }

  page: any

  getImageUrl(image){
    return this.doms.bypassSecurityTrustResourceUrl( environment.audioBaseDir + '/library/images/' + image )
  }


  sanitizeHtml( innerHtml ){
    return this.doms.bypassSecurityTrustHtml( innerHtml )
  }

  viewResearch(){

    const button = this.controller.getSectionComponents()[0].elements.find(({type}) => type == 'research-button')

    if( button && button.value ){
      window.open(button.value, "_blank")
      this.controller.next()
    }

  }

  ngOnInit() {
    this.page = this.controller.getSectionComponents()[0]
  }


  next(){
    this.controller.next()
  }
}
